//#region src/menu_item_display_price_precalculation.ts
let MenuItemDisplayPricePrecalculation = /* @__PURE__ */ function(MenuItemDisplayPricePrecalculation) {
	MenuItemDisplayPricePrecalculation["Off"] = "off";
	MenuItemDisplayPricePrecalculation["IncludeDefaultMods"] = "include-default-mods";
	MenuItemDisplayPricePrecalculation["IncludeCheapestModsOnRequiredGroups"] = "include-cheapest-mods-on-required-groups";
	return MenuItemDisplayPricePrecalculation;
}({});
//#endregion
export { MenuItemDisplayPricePrecalculation };

//# sourceMappingURL=menu_item_display_price_precalculation.js.map